import FIREBASEAPP from './firebase';
import ReactGA from 'react-ga';
ReactGA.initialize('UA-106533978-1');

let API = { getAllProfiles, sendEmail, trackingPage, trackingEvent };

function getAllProfiles(){
  return new Promise((resolve, reject ) => {
    let result = FIREBASEAPP.database().ref('positions').orderByChild('min-range');
    result.on('value', function(snap) {
      resolve( snap.val() );
    })
  }).catch( error => {
  })
}

function sendEmail(url, data, method){

  let request = new XMLHttpRequest();
  return new Promise( (resolve, reject) => {
    request.open(method, url, true);
    request.setRequestHeader('Content-type', 'application/json');
    request.onload = () => {
      if (request.status >= 200) {
        resolve(JSON.parse(request.response));
      }
    };
    request.onerror = () => {
      reject(new Error("Communication Error"));
    }
    request.send(data);
  });
}

function trackingPage(){
    ReactGA.set({
       page: window.location.pathname + window.location.search 
    });
    ReactGA.pageview(window.location.pathname + window.location.search);
    console.log("GA Page ", window.location.pathname,  window.location.search );
}

function trackingEvent(category, text){
  ReactGA.event({
    category: category,
    action: text
  });
  console.log("GA Event ", category, text);
}

export default API;



// WEBPACK FOOTER //
// ./src/api/index.js